// Sort home location first, then sort by name in alphabetical order (A-Z)
export const sortPlaces = (places = []) => {
  return [...places].sort((a, b) => {
    if (a.DefaultLocationUserHome === true) return -1;
    if (b.DefaultLocationUserHome === true) return 1;
    if (a.title > b.title) return 1;
    if (a.title < b.title) return -1;
    return 0;
  });
};

// Determines if the user has a place with the given placeId in their list of places
export const hasPlace = (places = [], placeId) => {
  if(!placeId || !Array.isArray(places)) return false;
  
  return places.some((place) => place.place_id === placeId);
};

// Adds a new place to the list of places if it doesn't already exist, then re-sorts the list
export const addPlaceToList = (places = [], newPlace) => {
  if (!newPlace || hasPlace(places, newPlace.place_id)) return places;

  return sortPlaces([...places, newPlace]);
};

export const setHomePlaceInList = (places = [], placeId) => {
  if (!hasPlace(places, placeId)) return places;

  return sortPlaces(
    places.map((place) => ({ ...place, DefaultLocationUserHome: place.place_id === placeId })),
  );
};

export const removePlaceFromList = (places = [], placeId) => {
  if (!hasPlace(places, placeId) || places.length <= 1) return places;

  return sortPlaces(places.filter((place) => place.place_id !== placeId));
};

// Renames a place in the list of places by matching the placeId and updating the title, then re-sorts the list
export const renamePlaceInList = (places = [], placeId, newName) => {
  if (!hasPlace(places, placeId)) return places;

  return sortPlaces(
    places.map((place) => (place.place_id === placeId ? { ...place, title: newName } : place)),
  );
};

export const getSelectedPlace = (places = [], selectedPlaceId, selectedSource) => {
  if (!Array.isArray(places) || places.length === 0) return null;

  if (selectedSource === 'default') {
    return places.find((place) => place.DefaultLocationUserHome) || places[0];
  }

  return places.find((place) => place.place_id === selectedPlaceId) || places[0];
};
